<template>
  <div class="container-fluid">
    <div class="row no-gutters" style="border-bottom: 2px solid black;">
      <div class="cell col-4"><strong>Yhteensä</strong></div>
      <div class="cell col-2"></div>
      <div class="cell col-3 text-right"><strong>tth</strong></div>
      <div class="cell col-3 text-right"><strong>Kust.eur</strong></div>
    </div>

    <div v-for="row in costRows" class="row no-gutters">
      <div class="cell col-1">{{ row.costCategoryCode }}</div>
      <div class="cell col-3">{{ row.costCategoryName }}</div>
      <div class="cell col-2"></div>
      <div v-if="row.costCategoryCode == 1" class="cell col-3 text-right">{{ (row.workHours || 0) | formatNumber }}</div>
      <div v-else="" class="cell col-3 text-right"></div>
      <div class="cell col-3 text-right">{{ row.cost |  formatNumber}}</div>
    </div>

    <div class="row no-gutters" style="border-top: 2px solid black;">
      <div class="cell col-9 text-right"><strong>Yhteensä</strong></div>
      <div class="cell col-3 text-right">{{ operation.totalCost | formatNumber }}</div>
    </div>
  </div>
</template>


<script>
  export default {
    props: ['operation'],

    data() {
      return {
//        split: 'sm'
        split: 'md'
      }
    },

    methods: {
      splitClass(clazz) {
        return clazz.replace('SPLIT', this.split)
      }
    },

    computed: {
      costRows() {
        return [
          { costCategoryCode: 1, costCategoryName: 'työ', cost: this.operation.workCost, workHours: this.operation.workHours },
          { costCategoryCode: 2, costCategoryName: 'materiaali', cost: this.operation.materialCost },
          { costCategoryCode: 3, costCategoryName: 'alihankinta', cost: this.operation.subcontractingCost },
          { costCategoryCode: 4, costCategoryName: 'kalusto', cost: this.operation.equipmentCost },
          { costCategoryCode: 5, costCategoryName: 'muu', cost: this.operation.otherCost }
        ]
      }
    }
  }
</script>


<style scoped>
  .cell {
    padding: 3px;
  }

  .container-fluid {
    padding: 0;
    margin-left: auto;
    margin-right: 0;
    width: 100%;
  }

  @media (min-width: 768px) {
    .container-fluid {
      width: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ResultPageOperationSumTable.vue